var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 252,
    viewBox: "0 0 379 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.6303C0 9.87493 18.0793 -3.5775 36.044 1.81067L103.027 21.9008C159.434 38.8191 219.566 38.8191 275.973 21.9008L342.956 1.81068C360.921 -3.57749 379 9.87493 379 28.6303V252H0V28.6303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRectangle);
export default __webpack_public_path__ + "static/media/white-rectangle.caf9430c13b4f2be3c5887fcf16f781f.svg";
export { ForwardRef as ReactComponent };